import { SearchCriteria } from '../../../common/models/list.model';
import { ListSearchCriteriaType } from './constants/list-search-criteria-type.constant';

export class ChangeSearchCriteriaByListType {
  static readonly type = '[ListSearchCriteria] Change ListSearchCriteria By List Type';
  constructor(
    public payload: {
      searchCriteria: Partial<SearchCriteria>;
      listSearchCriteriaType: ListSearchCriteriaType;
    },
  ) {}
}

export class SearchCriteriaInitialStateByListType {
  public static readonly type = '[ListSearchCriteria] Set initial state By List Type';
  constructor(public payload: ListSearchCriteriaType) {}
}
